import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable, finalize, of } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SectiuniService } from '../../sectiuni/sectiuni.service';
import { ISectiune } from '../../sectiuni/sectiuni.interface';
import { PermisiuniService } from '../permisiuni.service';
import {
  IPermisiuneAddPayload,
  IPermisiuneForm,
} from '../permisiuni.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-permisiune',
  templateUrl: './add-permisiune.component.html',
  styleUrls: ['./add-permisiune.component.scss'],
})
export class AddPermisiuneComponent implements OnInit {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;

  token!: string;
  isLoading = false;
  isSectionsLoading = true;
  sections$!: Observable<ISectiune[]>;

  form: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    section_id: new FormControl('', [Validators.required]),
    observations: new FormControl('', []),
  });

  constructor(
    private dialogRef: MatDialogRef<AddPermisiuneComponent>,
    private permisiuniService: PermisiuniService,
    private sectiuniService: SectiuniService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  ngOnInit(): void {
    this.getSectionsList();
  }

  getSectionsList() {
    this.sections$ = this.sectiuniService.getSections();
    this.sections$.subscribe({
      next: (sections) => {
        this.sections$ = of(sections);
        this.isSectionsLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.isSectionsLoading = false;
      },
    });
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.permisiuniService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const { name, section_id, observations } = this.form
      .value as IPermisiuneForm;
    const slug = name
      .split(' ')
      .map((item) => item.toLowerCase())
      .join('_');
    const newPermisiune: IPermisiuneAddPayload = {
      name,
      slug,
      section_id,
      observations,
    };

    this.permisiuniService
      .addPermisiune(newPermisiune)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
        },
      });
  }
}
